function onAuthflowCookiesWillSet(e) {
  if (__DEV__) {
    console.log('Web.Zephr:event: onAuthflowCookiesWillSet', e);
  }

  // Do something stub onAuthflowCookiesWillSet

  return;
}

export default onAuthflowCookiesWillSet;
